import { Bell } from "lucide-react";
import { cn } from "@/utils/cn";

export interface EmptyStateProps {
  size?: "sm" | "lg";
}

const SIZE_CLASSES = {
  sm: {
    icon: 28,
    wrapper: "gap-1.5 px-4 py-10 text-center",
    title: "text-sm",
    subtitle: "text-xs",
  },
  lg: {
    icon: 36,
    wrapper: "gap-1.5 py-16",
    title: "",
    subtitle: "text-[13px]",
  },
} as const;

function EmptyState({ size = "lg" }: EmptyStateProps) {
  const s = SIZE_CLASSES[size];

  return (
    <div className={cn("flex flex-col items-center justify-center", s.wrapper)}>
      <Bell size={s.icon} className="text-text-muted" strokeWidth={1.5} />
      <p className={cn("font-medium text-text-secondary", s.title)}>
        No notifications yet
      </p>
      <p className={cn("text-text-muted", s.subtitle)}>You're all caught up!</p>
    </div>
  );
}

export default EmptyState;
